<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form inline size="small">
        <el-form-item label="API账号ID">
          <el-input
            v-model="listQuery.api_account_id"
            placeholder="精确查询"
            clearable
            style="width: 120px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="价格方案ID">
          <el-input
            v-model="listQuery.price_plan_id"
            placeholder="精确查询"
            clearable
            style="width: 120px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="丽呈酒店ID">
          <el-input
            v-model="listQuery.hotel_id"
            placeholder="精确查询"
            clearable
            style="width: 120px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="房型ID">
          <el-input
            v-model="listQuery.roomtyp_id"
            placeholder="精确查询"
            clearable
            style="width: 100px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="产品ID">
          <el-input
            v-model="listQuery.product_id"
            placeholder="精确查询"
            clearable
            style="width: 100px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="价格ID">
          <el-input
            v-model="listQuery.rate_id"
            placeholder="精确查询"
            clearable
            style="width: 100px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="是否上架">
          <el-select
            v-model="listQuery.is_up"
            placeholder="请选择"
            clearable
            style="width: 100px"
          >
            <el-option label="上架" :value="1" />
            <el-option label="未上架" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="支付类型">
          <el-input
            v-model="listQuery.payment_type"
            placeholder="精确查询"
            clearable
            style="width: 100px"
          />
        </el-form-item>
        <el-form-item label="价格类型">
          <el-input
            v-model="listQuery.rate_category"
            placeholder="精确查询"
            clearable
            style="width: 100px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <li-cheng-sync-button
            resource="product"
            label="同步指定酒店产品"
            @synced="getList"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      stripe
      size="small"
    >
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="API账号ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.api_account_id }}
        </template>
      </el-table-column>

      <el-table-column label="价格方案ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.price_plan_id }}
        </template>
      </el-table-column>

      <el-table-column label="丽呈酒店ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_id }}
        </template>
      </el-table-column>

      <el-table-column label="酒店编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_code }}
        </template>
      </el-table-column>

      <el-table-column label="房型ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.roomtyp_id }}
        </template>
      </el-table-column>

      <el-table-column label="产品ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.product_id }}
        </template>
      </el-table-column>

      <el-table-column label="价格ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.rate_id }}
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status_flg === 1" type="success" size="mini">上线</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="支付类型" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.payment_type === 1" type="success" size="mini">预付</el-tag>
          <el-tag v-else-if="scope.row.payment_type === 2" type="info" size="mini">现付</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="早餐数量" min-width="90" align="center">
        <template slot-scope="scope">
          {{ scope.row.breakfast_cnt !== null ? scope.row.breakfast_cnt + '份' : '-' }}
        </template>
      </el-table-column>

      <el-table-column label="钟点房" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_hourly_room === 1" type="warning" size="mini">是</el-tag>
          <el-tag v-else-if="scope.row.is_hourly_room === 0" type="info" size="mini">否</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="上架状态" min-width="90" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_up === 1" type="success" size="mini">上架</el-tag>
          <el-tag v-else-if="scope.row.is_up === 0" type="info" size="mini">未上架</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="同步时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.sync_at }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>

      <el-table-column label="其他" min-width="80" align="center">
        <template slot-scope="scope">
          <span v-if="hasExtraData(scope.row)">...</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleViewDetail(scope.row)"
          >
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 查看详情弹窗 -->
    <el-dialog
      title="房型产品详情"
      :visible.sync="dialogDetailVisible"
      width="800px"
      :close-on-click-modal="true"
    >
      <div class="detail-content">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="API账号ID">
            {{ currentRow.api_account_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="价格方案ID">
            {{ currentRow.price_plan_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="丽呈酒店ID">
            {{ currentRow.hotel_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="酒店编码">
            {{ currentRow.hotel_code || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="房型ID">
            {{ currentRow.roomtyp_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="产品ID">
            {{ currentRow.product_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="价格ID">
            {{ currentRow.rate_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag v-if="currentRow.status_flg === 1" type="success" size="mini">上线</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="支付类型">
            <el-tag v-if="currentRow.payment_type === 1" type="success" size="mini">预付</el-tag>
            <el-tag v-else-if="currentRow.payment_type === 2" type="info" size="mini">现付</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="早餐数量">
            {{ currentRow.breakfast_cnt !== null ? currentRow.breakfast_cnt + '份' : '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="会员等级">
            {{ currentRow.member_rank_code || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="企业等级编码">
            {{ currentRow.corp_level_code || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="价格类型">
            {{ currentRow.rate_category || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="是否上架">
            <el-tag v-if="currentRow.is_up === 1" type="success" size="mini">上架</el-tag>
            <el-tag v-else-if="currentRow.is_up === 0" type="info" size="mini">未上架</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="是否钟点房">
            <el-tag v-if="currentRow.is_hourly_room === 1" type="warning" size="mini">是</el-tag>
            <el-tag v-else-if="currentRow.is_hourly_room === 0" type="info" size="mini">否</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="同步时间">
            {{ currentRow.sync_at || '无' }}
          </el-descriptions-item>
        </el-descriptions>

        <div class="jsonSection">
          <div class="json-label">价格JSON：</div>
          <div v-if="currentRow.rate" class="json-content">
            <pre>{{ formatJson(currentRow.rate) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="jsonSection">
          <div class="json-label">早餐列表：</div>
          <div v-if="currentRow.breakfast_list" class="json-content">
            <pre>{{ formatJson(currentRow.breakfast_list) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="jsonSection">
          <div class="json-label">钟点房信息：</div>
          <div v-if="currentRow.hourly_room_info" class="json-content">
            <pre>{{ formatJson(currentRow.hourly_room_info) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="jsonSection">
          <div class="json-label">预订须知：</div>
          <div v-if="currentRow.reservation_notice" class="json-content">
            <pre>{{ currentRow.reservation_notice }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="jsonSection">
          <div class="json-label">原始JSON：</div>
          <div v-if="currentRawJson" class="json-content">
            <pre>{{ currentRawJson }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      // 搜索参数
      listQuery: {
        page: 1,
        limit: 10,
        api_account_id: undefined,
        price_plan_id: undefined,
        hotel_id: undefined,
        roomtyp_id: undefined,
        product_id: undefined,
        rate_id: undefined,
        is_up: undefined,
        payment_type: undefined,
        rate_category: undefined,
        sort: 'id',
        order: 'DESC',
      },
      // 查看详情弹窗
      dialogDetailVisible: false,
      currentRow: {},
      currentRawJson: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 判断是否有额外数据
    hasExtraData(row) {
      return row.rate || row.breakfast_list || row.reservation_notice ||
        row.hourly_room_info || row.raw_json
    },
    // 格式化JSON字符串
    formatJson(jsonStr) {
      if (!jsonStr) return ''
      try {
        const parsed = JSON.parse(jsonStr)
        return JSON.stringify(parsed, null, 2)
      } catch (e) {
        return jsonStr
      }
    },
    // 获取列表数据
    getList() {
      this.listLoading = true

      // 处理空值参数
      const params = {}
      Object.keys(this.listQuery).forEach((key) => {
        const val = this.listQuery[key]
        if (val !== '' && val !== undefined && val !== null) {
          params[key] = val
        }
      })

      request({
        url: '/api/backend/liCheng/hotel/productList',
        method: 'get',
        params: params,
      })
        .then((response) => {
          this.list = response.data.items
          this.total = response.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 点击查询按钮
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    // 点击重置按钮
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        api_account_id: undefined,
        price_plan_id: undefined,
        hotel_id: undefined,
        roomtyp_id: undefined,
        product_id: undefined,
        rate_id: undefined,
        is_up: undefined,
        payment_type: undefined,
        rate_category: undefined,
        sort: 'id',
        order: 'DESC',
      }
      this.getList()
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    // 当前页码变化
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    // 查看详情
    handleViewDetail(row) {
      this.currentRow = Object.assign({}, row)
      if (row.raw_json) {
        try {
          const parsed = JSON.parse(row.raw_json)
          this.currentRawJson = JSON.stringify(parsed, null, 2)
        } catch (e) {
          this.currentRawJson = row.raw_json
        }
      } else {
        this.currentRawJson = ''
      }
      this.dialogDetailVisible = true
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  margin-bottom: 10px;
}
.pagination-container {
  margin-top: 20px;
}
.detail-content {
  max-height: 500px;
  overflow: auto;
}
.jsonSection {
  margin-top: 15px;
  .json-label {
    font-weight: bold;
    margin-bottom: 8px;
  }
  .json-content {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    max-height: 150px;
    overflow: auto;
    pre {
      margin: 0;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-size: 12px;
      line-height: 1.5;
      color: #333;
    }
  }
  .json-empty {
    text-align: center;
    padding: 15px;
    color: #999;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
}
</style>
